module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./OrderListView.js"));
	}, "OrderListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=OrderListView!./src/pages/Shop/Member/TradeManage/OrderList/OrderListView.js
// module id = 1521
// module chunks = 418